import { render, staticRenderFns } from "./RoundVideoAndStats.vue?vue&type=template&id=1a23452e&scoped=true&"
import script from "./RoundVideoAndStats.vue?vue&type=script&lang=js&"
export * from "./RoundVideoAndStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a23452e",
  null
  
)

export default component.exports